var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.604,
    height: 13.701,
    viewBox: "0 0 19.604 13.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05233a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-youtube",
    "data-name": "Icon simple-youtube",
    d: "M19.2,7.54A2.457,2.457,0,0,0,17.5,5.833c-1.528-.409-7.678-.409-7.678-.409s-6.134-.008-7.678.409A2.457,2.457,0,0,0,.434,7.54a25.533,25.533,0,0,0-.427,4.744,25.533,25.533,0,0,0,.427,4.726A2.457,2.457,0,0,0,2.14,18.715c1.526.41,7.678.41,7.678.41s6.133,0,7.678-.41A2.457,2.457,0,0,0,19.2,17.009a25.533,25.533,0,0,0,.409-4.726A25.533,25.533,0,0,0,19.2,7.54ZM7.855,15.217V9.34l5.119,2.943Z",
    transform: "translate(-0.007 -5.424)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.49e00bb6ec0e506c5c9e415dd3d3025f.svg";
export { ForwardRef as ReactComponent };